import React from 'react'
import { Aside, Body, Heading, HorizontalSpacer, Link, TextVerticalSpacer } from '@superhi/design'

import { buildPath } from '../../../../../../routing/utils'

import { Wrapper } from './styles'

type Post = {
  id: string
  slug: string
}

type Props = {
  title: string
  slug: string
  currentPostSlug: string
  posts: Post[]
}

const GuideInfo: React.FC<Props> = ({ title, slug, posts = [], currentPostSlug }) => {
  const currentIndex = posts.findIndex((post) => post.slug === currentPostSlug)
  const previousUrl = React.useMemo(
    () => (posts[currentIndex - 1]?.slug ? `/posts/${posts[currentIndex - 1].slug}` : undefined),
    [currentIndex, posts],
  )
  const nextUrl = React.useMemo(
    () => (posts[currentIndex + 1]?.slug ? `/posts/${posts[currentIndex + 1].slug}` : undefined),
    [currentIndex, posts],
  )

  return (
    <Wrapper data-component-name="GuideInfo">
      <Aside label="Curently reading" level="2">
        <TextVerticalSpacer level="4">
          <Heading level="4">
            <Link href={buildPath('guides-view', { params: { guideSlug: slug } })}>{title}</Link>
          </Heading>

          <HorizontalSpacer amount={{ small: 16, medium: 16, large: 16 }}>
            <Body level="3" inline>
              Chapter {currentIndex + 1} of {posts.length}
            </Body>
            {previousUrl && (
              <Body level="3" inline>
                <Link href={previousUrl}>Previous</Link>
              </Body>
            )}
            {nextUrl && (
              <Body level="3" inline>
                <Link href={nextUrl}>Next</Link>
              </Body>
            )}
          </HorizontalSpacer>
        </TextVerticalSpacer>
      </Aside>
    </Wrapper>
  )
}

export default GuideInfo
